module.exports = __webpack_public_path__ + "static/media/Internal Medicine-Medical and Social History Intake-1@3x.acce7cc4.png";